import { jsx as _jsx } from "react/jsx-runtime";
import { uploadEventImage } from '../../api/event-images';
import { EntityBulkUploadModal } from '../EntityBulkUploadModal/EntityBulkUploadModal';
export const EventsBulkUploadModal = (props) => (_jsx(EntityBulkUploadModal, Object.assign({}, props, { title: "Bulk Upload Event Backgrounds", upload: uploadEventImage, uploadView: "fileList", resultView: "summaryWithErrors" })));
